function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.434 3C16.752 3.00006 17.0653 3.07593 17.3481 3.22132C17.6309 3.36671 17.8749 3.57743 18.06 3.836L18.149 3.971L20.573 8.011C20.8119 8.40941 20.955 8.85786 20.991 9.321L21 9.554V19C21.0002 19.5046 20.8096 19.9906 20.4665 20.3605C20.1234 20.7305 19.6532 20.9572 19.15 20.995L19 21H5C4.49542 21.0002 4.00943 20.8096 3.63945 20.4665C3.26947 20.1234 3.04284 19.6532 3.005 19.15L3 19V9.554C3.00003 9.08888 3.10821 8.63013 3.316 8.214L3.428 8.01L5.85 3.971C6.0136 3.69815 6.23994 3.46826 6.51021 3.30043C6.78048 3.13259 7.08689 3.03166 7.404 3.006L7.566 3H16.434ZM19 10H5V19H19V10ZM11 5H7.566L5.766 8H11V5ZM16.434 5H13V8H18.234L16.434 5Z",
  fill: "black"
});

function SvgOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.bc6b3b471587c7cbcbf88e7aa84ac7be.svg";
export { ForwardRef as ReactComponent };